import { connect } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';

const ProtectedRoute = ({
    userSessionRx,
    userLocalRx,
    component: Component,
    ...rest
}) => {
    const location = useLocation();
    const isAuthenticated = userSessionRx || userLocalRx;

    if (!isAuthenticated) {
        return <Navigate to={`/login?redirect=${location.pathname}`} replace />;
    }

    return <Component {...rest} />;
};

const mapStateToProps = state => ({
    userSessionRx: state.auth.user,
    userLocalRx: state.authPersist.user,
});

export default connect(mapStateToProps)(ProtectedRoute);
